export default "__VITE_ASSET__Jd6NmnUO__"